module.exports = __webpack_public_path__ + "img/cloud.0d8638b1.png";